// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EllipsisOutlinedSvg from "@ant-design/icons-svg/es/asn/EllipsisOutlined";
import AntdIcon from '../components/AntdIcon';

var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EllipsisOutlinedSvg
  }));
};

EllipsisOutlined.displayName = 'EllipsisOutlined';
export default /*#__PURE__*/React.forwardRef(EllipsisOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/EllipsisOutlined.js
// module id = 147
// module chunks = 0